import { Client } from 'persona';

import { PersonaConfig } from '../domain/config';

const runPersona = async ({ templateId, environment }: PersonaConfig): Promise<string> => {
  return new Promise((resolve, reject) => {
    const client = new Client({
      templateId,
      environment,
      onReady: () => {
        client.open();
      },
      onComplete: ({ inquiryId }) => {
        resolve(inquiryId);
      },
      onCancel: () => {
        reject(new Error('Persona verification cancelled'));
      },
      onError: () => {
        resolve('persona_error');
      },
    });
  });
};

export { runPersona };
